import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useResolveConflict = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onResolveConflictError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while resolving the conflict.',
    );
  };

  const onResolveConflictSuccess = (callback?: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Conflict resolved successfully.');
    if (callback) callback();
  };

  const resolveConflict = (data: any, callback?: () => void) => {
    const url: HttpConfig = {
      url: `api/v1/company/hiring-conflicts/${data?.id}/resolve`,
      method: 'patch',
      // data: {},
    };
    request(url, onResolveConflictSuccess(callback), setLoading, onResolveConflictError);
  };

  return { resolveConflict, loading };
};

export default useResolveConflict;
